// extracted by mini-css-extract-plugin
export default {"surveyResultsCon":"Surveys_surveyResultsCon__aDHjd","content":"Surveys_content__B6Hi-"};